import { MovableInkPanel } from 'modules/movableInk';
import { useModalContext } from 'utils/contexts/modal';
import { useWYSIWYGContext } from '../../contexts/WYSIWYGContext';
import { useHandleMovableInkInsert } from '../../hooks';

export const MovableInkPanelModal = () => {
  const { selectedImage, selectedImageAnchor } = useWYSIWYGContext();
  const { hideModal } = useModalContext();
  const handleMovableInkInsert = useHandleMovableInkInsert();

  return (
    <MovableInkPanel
      onClose={hideModal}
      onInsert={handleMovableInkInsert}
      selectedEditorImageNode={selectedImage}
      selectedEditorImageAnchorNode={selectedImageAnchor}
    />
  );
};
